import { BoValues } from './types';
import _isEmpty from 'lodash-es/isEmpty';

export function isReferentielValuesEmpty(bo: BoValues): boolean {
  return (
    _isEmpty(bo.matiere || []) &&
    (bo?.domaine || []).length === 0 &&
    (bo?.competence || []).length === 0 &&
    (bo?.goals || []).length === 0
  );
}
